// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { AuthBaseEntity } from '../auth-base-entity';
import { Feature } from './feature';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class FeatureSetting extends AuthBaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  createdAt!: Date;
  createdBy?: string;
  featureId!: number;
  isPracticeSpecific!: boolean;
  practiceId!: number;
  settingDataType!: string;
  settingDateTime!: Date;
  settingDateTimeOffset!: Date;
  settingId!: string;
  settingInt!: number;
  settingName!: string;
  settingString?: string;
  settingType!: string;
  ts?: any;
  updatedAt!: Date;
  updatedBy?: string;
  feature!: Feature;
}

